import {
	Box,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { useState } from "react";
import CommCard from "src/common/CommCard";
import { CommonPagination } from "src/common/CommonPagination";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import type { IB2B_list } from "../type/b2bType";
import B2BTableRow from "./B2BTableRow";
import B2BReportExcelGeneration from "./B2BReportExcelGeneration";

const B2BList = () => {
	const [pagination, setPagination] = useState({
		limit: 50,
		skip: 0,
	});
	const [dateRange, setDateRange] = useState<{
		start_date: string;
		end_date: string;
	}>({
		start_date: "",
		end_date: "",
	});
	const [searchParams, setSearchParams] = useState({ name: "", type: "" });
	const { data, isLoading } = useGetQueryWithTotal<IB2B_list[]>({
		endPoint: "/api/fair/admin/b2b",
		queryKeys: ["B2B"],
		params: {
			...pagination,
			name: searchParams.name,
			type: searchParams.type,
			dateRange,
		},
	});
	return (
		<>
			<CommCard
				showSearch
				searchPlaceHolder='Organization or First & Last Name'
				showCardHeader
				showStatus
				statusLabel='Type'
				statusOptions={[
					{ id: "Buyer", name: "Buyer" },
					{ id: "Seller", name: "Seller" },
					{ id: "Both", name: "Both" },
				]}
				handleSelectStatus={(e) => {
					setSearchParams((prev) => ({ ...prev, type: e }));
					setPagination((prev) => ({ ...prev, skip: 0 }));
				}}
				headerTitle={`Buyer/Seller B2B List (${data?.total ?? 0})`}
				handleSearchFun={(name) => {
					setSearchParams((prev) => ({ ...prev, name }));
					setPagination((prev) => ({ ...prev, skip: 0 }));
				}}
				helmetTitle='BTTF - Buyer/Seller B2B list'
				handleDateRange={(date) => {
					setDateRange(date);
					setPagination((prev) => ({ ...prev, skip: 0 }));
				}}
				showDateRange
				componentChildren={
					<B2BReportExcelGeneration
						searchParams={searchParams}
						dateRange={dateRange}
						totalCount={data?.total}
						currentData={data?.data}
						isLoading={isLoading}
					/>
				}
			>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>SL.</TableCell>
								<TableCell>Name</TableCell>
								<TableCell>Designation</TableCell>
								<TableCell>Organization</TableCell>
								<TableCell>B2B Type</TableCell>
								<TableCell>Phone</TableCell>
								<TableCell>Email</TableCell>
								<TableCell>Status</TableCell>
								<TableCell>Action</TableCell>
							</TableRow>
						</TableHead>

						{isLoading ? (
							<TableLoader />
						) : data?.data ? (
							<TableBody>
								{data?.data?.map((allAdmin, index) => (
									<B2BTableRow
										key={allAdmin.b2b_id}
										b2bData={allAdmin}
										paginationSkip={pagination.skip}
										index={index}
									/>
								))}
							</TableBody>
						) : (
							<TableNotFound />
						)}
					</Table>
				</TableContainer>

				<Box p={2}>
					<CommonPagination
						total={data?.total}
						paginationCalFun={(limit: number, skip: number) => {
							setPagination({ limit, skip });
						}}
					/>
				</Box>
			</CommCard>
		</>
	);
};

export default B2BList;
